import * as resourceApi from '@/api/resources'

import {
  FETCH_RESOURCE,
  FETCH_RESOURCES,
  FETCH_RESOURCES_FAILURE,
  FETCH_RESOURCES_SUCCESS,
  FETCH_RESOURCE_FAILURE,
  FETCH_RESOURCE_SUCCESS
} from '../mutation-types'

const actions = {
  fetchResources: async ({ commit }) => {
    try {
      commit(FETCH_RESOURCES)
      const response = await resourceApi.fetchResources()
      commit(FETCH_RESOURCES_SUCCESS, response.data)
    } catch (error) {
      console.error(error)
      commit(FETCH_RESOURCES_FAILURE, error)
    }
  },
  fetchResource: async ({ dispatch, commit, state, getters }, { resourceType, resourceId }) => {
    try {
      commit(FETCH_RESOURCE)
      if (getters.isResourcesLoaded === false) {
        await dispatch('fetchResources')
      }
      const resourceUrl = getters.getResourceUrl(resourceType, resourceId)
      console.log(resourceUrl)
      const response = await resourceApi.fetchResourceByUrl(resourceUrl)
      commit(FETCH_RESOURCE_SUCCESS, response.data)
    } catch (error) {
      console.error(error)
      commit(FETCH_RESOURCE_FAILURE, error)
    }
  }

}

export default actions
